import { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { ActiveSessions } from "@/components/active-session";

interface SplitViewProps extends PropsWithChildren {
  className?: string;
  style?: React.CSSProperties;
  hasBorder?: boolean;
  dataTestId?: string;
}

export const SplitView: FC<SplitViewProps> = ({
  children,
  hasBorder = false,
  dataTestId = "",
}) => {
  return (
    <Container data-component="SplitView">
      <MainPanel data-test-id={dataTestId} hasBorder={hasBorder} data-component="MainPanel">
        <CenterPanel data-component="CenterPanel">
          {children}
          <ActiveSessions />
        </CenterPanel>
      </MainPanel>
    </Container>
  );
};

const Container = styled.div({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  justifyContent: "center",
  margin: "0 auto",
  maxWidth: "100%",
  width: "100%",
});

interface MainPanelProps {
  hasBorder: boolean;
}

const MainPanel = styled("div", {
  shouldForwardProp: prop => prop !== "hasBorder",
})<MainPanelProps>(({ hasBorder, theme }) => ({
  alignSelf: "center",
  boxSizing: "border-box",
  containerName: "mds-panel",
  containerType: "inline-size",
  display: "flex",
  flex: "1 1 0",
  height: "100%",
  minWidth: 0,
  overflow: "hidden",
  position: "relative",
  width: "100%",
  border: "none",

  ...(hasBorder
    ? {
        "@media (max-width: 899px)": {
          width: "100%",
        },

        "@media (min-width: 900px)": {
          border: `1px solid ${theme.colors.border.default}`,
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          boxShadow: "0px 2px 4px rgba(69, 79, 104, 0.1)",
        },
      }
    : {}),
}));

const CenterPanel = styled.div({
  boxSizing: "border-box",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  overflow: "hidden",
  position: "relative",
  minWidth: 0,
  minHeight: 0,
});
